import { board } from '../../api'

const state = {
  notice: {
    response: {
      list: []
    },
    last_page: ''
  },
  noticeDetail: []
}

const getters = {
  getNoticeList: state => state.notice.response.list,
  getNoticePage: state => state.notice.last_page,
  getNoticeDetail: state => state.noticeDetail
}

const mutations = {
  SET_NOTICE (state, payload) {
    state.notice = payload
  },
  SET_NOTICE_DETAIL (state, payload) {
    state.noticeDetail = payload
  },
  SET_NOTICE_MAIN (state, payload) {
    state.notice = payload
  }
}

const actions = {
  NOTICE_LIST ({ commit }, payload) {
    return board.noticeList(payload)
      .then((data) => commit('SET_NOTICE', data.results))
  },
  NOTICE_DETAIL ({ commit }, code) {
    return board.noticeDetail(code)
      .then((data) => commit('SET_NOTICE_DETAIL', data.response))
  },
  NOTICE_LIST_MAIN ({ commit }) {
    return board.noticeListMain()
      .then((data) => commit('SET_NOTICE_MAIN', data.results))
  }
}

export default {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
